import script from "./WebinarStudioChat.vue?vue&type=script&setup=true&lang=js"
export * from "./WebinarStudioChat.vue?vue&type=script&setup=true&lang=js"

import "./WebinarStudioChat.vue?vue&type=style&index=0&id=42cd0e70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42cd0e70"]])

export default __exports__